import { post } from "@insite/client-framework/Services/ApiService";

// Same payload as WhiteCap Canada, plus the National Ladder fields (country, orderNumber).
export interface ContactUsApiParameter {
    type?: string;
    name?: string;
    emailAddress?: string;
    phone?: string;
    city?: string;
    province?: string;
    country?: string;
    orderNumber?: string;
    requestType?: string;
    branch?: string | null;
    message?: string;
}

const contactUsUrl = "/api/v1/communication";

export function contactUsService(parameter: ContactUsApiParameter) {
    return post<ContactUsApiParameter, void>(`${contactUsUrl}`, parameter);
}
